import { Component, inject, Injector, Input } from '@angular/core';
import { LambdaFunctionService } from '../../../service/lambda-function.service';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../../../http.service';
import { setTime } from 'ngx-bootstrap/chronos/utils/date-setters';
import { OrgIndividualTeamsComponent } from '../org-individual-teams.component';

@Component({
  selector: 'app-download-team-graph',
  templateUrl: './download-team-graph.component.html',
  styleUrls: ['./download-team-graph.component.scss']
})
export class DownloadTeamGraphComponent {

  team: any;
  clarifier_low:number = 0;
  clarifier_high:number = 0;
  ideator_low:number = 0;
  ideator_high:number = 0;
  developer_low:number = 0;
  developer_high:number = 0;
  implementor_low:number = 0;
  implementor_high:number = 0;
  clarifier_neutral:number = 0;
  ideator_neutral:number = 0;
  developer_neutral:number = 0;
  implementor_neutral:number =0;
  integrator:number = 0;
  highest_score:number = 0;
  total_members:number = 0;
  date;
  args:any;
  env = environment;
  currentTeamId;
  pdfLink;
  loadingMembers = false;
  loader = false;
  loader_text = 'Generating PDF';
  individualArgs:any;
  content_type;
  format = "letter";
  injectedCompo;
  groupProfileType:any;
  individualProfileArgsArr:any = [];

  constructor(private lmbda_service: LambdaFunctionService, private httpService: HttpService, public injector: Injector) {
    this.injectedCompo = this.injector.get(OrgIndividualTeamsComponent);
  }

  ngOnInit() {
    this.date = new Date();
    console.log('teams data here', this.team)
  }

    public async setGraphData(currentTeam) {
    this.total_members = currentTeam.memberships_count;
    currentTeam?.memberships?.forEach(list => {
        if(list?.default_profile){
            if(list?.default_profile?.clarifier_score == 'Low'){
                this.clarifier_low = this.clarifier_low + 1;
                if( this.clarifier_low > this.highest_score ){
                    this.highest_score = this.clarifier_low;
                }
            }
  
            if(list?.default_profile?.clarifier_score == 'High'){
                this.clarifier_high = this.clarifier_high + 1;
                if( this.clarifier_high > this.highest_score ){
                    this.highest_score = this.clarifier_high;
                }
            }
  
            if(list?.default_profile.ideator_score == 'Low'){
                this.ideator_low = this.ideator_low + 1;
                if( this.ideator_low > this.highest_score ){
                    this.highest_score = this.ideator_low;
                }
            }
  
            if(list?.default_profile?.ideator_score == 'High'){
                this.ideator_high = this.ideator_high + 1;
                if( this.ideator_high > this.highest_score ){
                    this.highest_score = this.ideator_high;
                }
            }
  
            if(list?.default_profile.developer_score == 'Low'){
                this.developer_low = this.developer_low + 1;
                if( this.developer_low > this.highest_score ){
                    this.highest_score = this.developer_low;
                }
            }
  
            if(list?.default_profile?.developer_score == 'High'){
                this.developer_high = this.developer_high + 1;
                if( this.developer_high > this.highest_score ){
                    this.highest_score = this.developer_high;
                }
            }
  
            if(list?.default_profile?.implementer_score == 'Low'){
                this.implementor_low = this.implementor_low + 1;
                if( this.implementor_low > this.highest_score ){
                    this.highest_score = this.implementor_low;
                }
            }
  
            if(list?.default_profile?.implementer_score == 'High'){
                this.implementor_high = this.implementor_high + 1;
                if( this.implementor_high > this.highest_score ){
                    this.highest_score = this.implementor_high;
                }
            }
  
            //   neutral profiles
            if(list?.default_profile?.clarifier_score == 'Neutral') {
              this.clarifier_neutral += 1; 
            }
            if(list.default_profile.ideator_score == 'Neutral') {
              this.ideator_neutral += 1; 
            }
            if(list.default_profile.developer_score == 'Neutral') {
              this.developer_neutral += 1; 
            }
            if(list.default_profile.implementer_score == 'Neutral') {
              this.implementor_neutral += 1; 
            }
            if(list?.default_profile?.clarifier_score == 'Neutral' && list.default_profile.ideator_score == 'Neutral' && list.default_profile.developer_score == 'Neutral' && list.default_profile.implementer_score == 'Neutral'){
              this.integrator += 1;
              }
  
        }
  
    });
    $('.graph-loader').css('display','none')
    await this.setArgs()
  }

   public setArgs() {
    let name = this.team.name;
    let membershipcount = this.team.memberships_count;
    let org_id = this.team.organization_id;
    let org_name = this.team.organization_name;
    let date = String(this.date.getFullYear()) + String((this.date.getMonth() + 1)) + String(this.date.getDate());
    let time = String(this.date.getHours()) + String(this.date.getMinutes());
    this.args = {
      "function_name": "plus-GroupProfileFunction-6y5p4TgXuqZA",
      "invocation_type": "RequestResponse",
      "log_type": "None",
      // "id": currentTeam.all_members[0]?.default_profile?.team_id,
      "template": "team_pf.html",
      "filename": org_name+ '-' + date + time,
      "memberships_count": membershipcount,
      "name": name,
      "organization_title": "Organization",
      "organization_id": org_id,
      "organization_name": org_name,
      "clarifier_low": this.clarifier_low ? this.clarifier_low : 0,
      "clarifier_neutral": this.clarifier_neutral ? this.clarifier_neutral : 0,
      "clarifier_high": this.clarifier_high ? this.clarifier_high : 0,
      "ideator_low": this.ideator_low ? this.ideator_low : 0,
      "ideator_neutral": this.ideator_neutral ? this.ideator_neutral : 0,
      "ideator_high": this.ideator_high ?  this.ideator_high : 0,
      "developer_low": this.developer_low ? this.developer_low : 0,
      "developer_neutral": this.developer_neutral ? this.developer_neutral : 0,
      "developer_high": this.developer_high ? this.developer_high : 0,
      "implementor_low": this.implementor_low ? this.implementor_low : 0,
      "implementor_neutral": this.implementor_neutral ? this.implementor_neutral : 0,
      "implementor_high": this.implementor_high ? this.implementor_high : 0,
      "integrator": this.integrator ?  this.integrator : 0,
      "highest_score": this.highest_score ? this.highest_score : 0,
      "app_type": "Group Profile Plus",
      "pdf_type": "letter",
      "email": "sarah@blairmiller.com",
      // "today_date": this.date,
      "content_type": 'pdf',
      "profile_type": "Ask",
      "description": "Look at your graph. What do you notice? What, if anything, is surprising? Where does this group need to pay deliberate attention so they can succeed? Think of a project or a challenge this group has recently been engaged in. Describe how the group approached the project using the group profile as a guide.",
      "footer_imptext": "FourSight® Group Profile",
      "footer_text": "provides a snapshot of how a group's energy will likely rise and fall as people work together through the four stages of the universal problem solving process. The numbers indicate how many individuals in the group have a high, neutral, or low thinking preference for each stage.",
      "remember": "Preference <span>=</span> Energy",
      "team_des": "FourSight is a measure of thinking preference, not ability. A preference is a measure of energy, not talent. People with a high preference tend to gravitate to that stage of the problem-solving process. People with a low preference tend to move quickly through it. People with a neutral preference tend to do the work and move on. All three approaches can lead to problem-solving success. Teams are more likely to succeed when people are both self-aware and process aware.",
      "footer_des": null,
    }
    console.log("args for team", this.args)
  }

  public SelectDownloadType(type, format='letter') {
    this.individualProfileArgsArr = [];
    this.content_type = type;
    this.format = format
    this.pdfLink = ''
    this.injectedCompo.slectedIndividualTeamArr.forEach(async (el) => {
      console.log('el', el)
      this.createArgsAndDownload(el);
    })
  }

  public createArgsAndDownload(item) {
    this.loader = true;
    this.individualArgs = {
      "content_type": this.content_type,
      "filename": "foursight-roster"+ item.id + '-profile' + new Date().getTime(),
      "format": this.format,
      "members": [],
      "organization": "organization",
      "template": "multi-profile.html"
    }
    if(this.injectedCompo.slectedIndividualTeamArr.length == 1) {
     this.individualArgs['downloadAble'] = true
    }
    item?.memberships.forEach((team) => {
      if(team.default_profile) {
        team['default_profile']['thinking_profile_heading'] = 'FourSight<sup>®</sup> Thinking Profile</span>';
        team['default_profile']['thinking_profile_message'] = 'measures where you gain energy in the innovation process. There are no "good" or "bad" scores. Each of these four preferences has its own strengths and potential weaknesses. The goal is not to change your preferences, but to understand how your preferences are affecting your decision making, your perceptions, your stress levels and your interactions with others.';
        team['default_profile']['organization_title'] = 'Organization';
        team['default_profile']['organization'] = 'Organization';
        team['default_profile']['low_preference'] = 'Low Preference';
        team['default_profile']['high_preference'] = 'High Preference';
        team['default_profile']['contrast'] = 'Neutral';
        team['default_profile']['clarify'] = 'Clarify';
        team['default_profile']['ideate'] = 'Ideate';
        team['default_profile']['develop'] = 'Develop';
        team['default_profile']['implement'] = 'Implement';
        team['default_profile']['prefers_to'] = 'prefers to';
        team['default_profile']['get_report'] = 'Get your full report at';
        team['default_profile']['sign_up_with'] = 'Sign up with the email';
        this.individualArgs["members"].push(team.default_profile)
      }
    })
    this.individualProfileArgsArr.push(this.individualArgs)
    console.log("data", this.individualArgs)
    this.loader = false;
  }

  public DownloadThinkingProfile() {
    let pdfUrls = [];
    this.loader = true;
    this.loader_text = "Generating PDF";
    console.log(this.individualProfileArgsArr)
    this.individualProfileArgsArr.forEach(async (el) => {
      this.lmbda_service.lambda_invoke('thinking-ProfileFunction-pxVk1VnOrZ3r',el)
      this.lmbda_service.lambda_res.subscribe((output)=> {
        if(this.individualProfileArgsArr.length == 1) {
          this.pdfLink = output;
          console.log("pdfLink", this.pdfLink)
          if(output.length) {
            setTimeout(() => {
              this.loader = false;
            }, 1000);
          }
        } else {
          if(output.length && !pdfUrls.includes(output)) {
            window.open(output, '_blank');
            pdfUrls.push(output);
            this.pdfLink = '';
            setTimeout(() => {
                this.loader = false;
              }, 1000);
          }
        }
      })
    })
  }

  public fetchMembers(){
     this.injectedCompo.slectedIndividualTeamArr.forEach(async (el) => {
      console.log('el', el)
      if(el.memberships_count > 20 && el.memberships.length != el.memberships_count ) {
        let allTeamMem: any = this.httpService.getRequest(
      `${environment.profileURL}/api/v1/teams/` +
        el.id +
        `/memberships.json?name_order=asc&per_page=${el.memberships_count}`
      );
      allTeamMem.subscribe((res) => {
        el.memberships = res.memberships;
        console.log('res here', res)
        // this.createArgsAndDownload()
        // this.setGraphData(this.team)
        this.loadingMembers = false;
        // console.log("showing all members",this.teams);
      });
      }
    })
  }

  public downloadGraph(){
    console.log(this.team)
    this.loader = true;
    this.lmbda_service.lambda_invoke('plus-GroupProfileFunction-6y5p4TgXuqZA',this.args)
    this.lmbda_service.lambda_pdf.subscribe((output)=> {
      this.pdfLink = output;
      console.log("pdfLink", this.pdfLink)
      if(output.length) {
        setTimeout(() => {
          this.loader = false;
        }, 1000);
      }
    })
  }

  public openClosePDFPopup() {
    this.injectedCompo.openPdfPopup = !this.injectedCompo.openPdfPopup;
    this.fetchMembers()
  }

  // downloading Selected group profile
  public async downloadSelectedTeams(type) {
    console.log('selectedGroupProfileTeamsArr', this.injectedCompo.selectedGroupProfileTeamsArr)
    this.injectedCompo.selectedGroupProfileTeamsArr.forEach(async (el) => {
      this.loader = true;
      this.loader_text = "Generating PDF";
      if(this.injectedCompo.selectedGroupProfileTeamsArr.length == 1) {
        el['downloadAble'] = false
      } else {
        el['downloadAble'] = true
      }
      el['content_type'] = type

      await this.injectedCompo.http.post(`${environment.profileURL}/api/v1/lambda_functions/invoke.json`,{name:"plus-GroupProfileFunction-6y5p4TgXuqZA",options:el}).subscribe((result)=> {
        if(result['response'].body) {
          this.loader = false;
          if(this.injectedCompo.selectedGroupProfileTeamsArr.length == 1) {
            this.pdfLink = result['response'].body;
          } else {
            window.open(result['response'].body, '_blank');
          }
        }
      })
    })
  }

}
